<template>
    <Head title="Login" />
  <div class="flex items-center justify-center min-h-screen p-6 light">
      <flash-messages />
    <div class="w-full max-w-md">
        <Link :href="route('home')"><logo class="block w-full max-w-xs mx-auto fill-white" height="50" /></Link>
      <form class="mt-8 overflow-hidden bg-white border border-gray-100 rounded-lg shadow-xl dark:bg-slate-900" @submit.prevent="login">
        <div class="px-10 py-12">
          <h2 class="text-xl font-bold text-center">{{ __('Login - Student Support Center!') }}</h2>
          <div class="w-24 mx-auto mt-3 border-b" />
          <text-input v-model="form.email" :error="form.errors.email" class="mt-10" label="Email" type="email" autofocus autocapitalize="off" />
          <div class="password-input-container">
            <text-input v-model="form.password" :type="passwordFieldType" :error="form.errors.password" class="mt-6" label="Password" type="password" />
            <i :class="passwordFieldType === 'password' ? 'fa fa-eye' : 'fa fa-eye-slash'" class="toggle-password-icon" @click="togglePasswordVisibility"></i>
          
          </div>
          <label class="flex items-center mt-6 select-none" for="remember">
            <input id="remember" v-model="form.remember" class="mr-1" type="checkbox" />
            <span class="text-sm">Remember Me</span>
          </label>
            <loading-button :loading="form.processing" class="items-center justify-center w-full mt-8 ml-auto btn-indigo" type="submit">{{ __('Login') }}</loading-button>
            <div class="flex justify-center mt-5"><Link class="ml-2 " :href="route('password.reset')">{{ __('Forgot your password?') }}</Link></div>
            <div class="flex justify-center mt-5">Don’t have account? <Link class="ml-2 " :href="route('register')">{{ __('Register') }}</Link></div>
        </div>
          <div class="flex flex-col items-center gap-1 py-4 bg-gray-100 border-t border-gray-100 dark:bg-slate-900 dark:border-gray-700 login-as" v-if="is_demo">
              <h2 class="mb-3 text-sm font-bold">Login As: </h2>
              <div class="flex flex-col gap-3 action sm:flex-row">
                  <button class=" btn-indigo" @click="autofillLogin($event, 'admin')">Admin</button>
                  <button class=" btn-indigo" @click="autofillLogin($event,'manager')">Manager</button>
                  <button class=" btn-indigo" @click="autofillLogin($event,'student')">Student</button>
              </div>
          </div>
      </form>
    </div>
  </div>
</template>

<script>
import Logo from '@/Shared/Logo'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import { Head, Link } from '@inertiajs/inertia-vue3'
import FlashMessages from '@/Shared/FlashMessages'

export default {
  metaInfo: { title: 'Login' },
  components: {
      FlashMessages,
    LoadingButton,
    Logo,
    TextInput,
      Head,
      Link,
  },
    props: {
        is_demo: Number
    },
  data() {
    
    return {
      showPassword: false,
      form: this.$inertia.form({
        email: '',
        password: '',
        remember: false,
      }),
    }
  },
  computed: {
    passwordFieldType() {
      return this.showPassword ? 'text' : 'password';
    },
  },
  methods: {
      login() {
          this.form.post(this.route('login.store'))
      },
      togglePasswordVisibility() {
        this.showPassword = !this.showPassword;
      },
      autofillLogin(e, role){
          e.preventDefault()
          const roleEmails = { 'admin': 'john.due.helo@mail.com', 'manager': 'robert.slaughter@mail.com', 'student' : 'mmarks@example.com'}
          this.form.email = roleEmails[role]
          this.form.password = 'secret'
          this.login();
      }
  }
}
</script>

<style>
.password-input-container {
  position: relative;
  /* display: flex; */
  /* align-items: center; */
}

.toggle-password-icon {
  position: absolute;
  right: 10px;
  top: 60%;
  cursor: pointer;
}
</style>
